import { render, staticRenderFns } from "./CrmEditProperties.vue?vue&type=template&id=0159556a"
import script from "./CrmEditProperties.vue?vue&type=script&lang=ts"
export * from "./CrmEditProperties.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0159556a')) {
      api.createRecord('0159556a', component.options)
    } else {
      api.reload('0159556a', component.options)
    }
    module.hot.accept("./CrmEditProperties.vue?vue&type=template&id=0159556a", function () {
      api.rerender('0159556a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/crm/CrmEditProperties.vue"
export default component.exports